import apiClient, { plainApiClient } from "..";

export const usersAccount = ({ userId }) => {
  return apiClient.get(`accountName?UserId=${userId}`);
};

export const emailIdsTax = ({ empCode, userId }) => {
  return apiClient.get(`GetEmail?EmpCode=${empCode}&UserId=${userId}`);
};

export const emailIdsTaxClient = ({ userId }) => {
  return apiClient.get(`GetEmail?EmpCode=&UserId=${userId}`);
};

export const portfolioAssetClasses = ({ isFamily, id }) => {
  return apiClient.get(`${isFamily}/${id}/portfolioassetclasses`);
};

export const subAssetClassData = ({ isFamily, id, assetClassId }) => {
  return apiClient.get(
    `${isFamily}/${id}/portfolioassetclasses?classType=SubAssetClass&assetClassId=${assetClassId}`
  );
};

export const getDenominations = ({ isOffshore, signal }) => {
  const url = `/denominations?isoffshore=${isOffshore}`;
  return signal ? apiClient.get(url, { signal }) : apiClient.get(url);
};

export const sections = () => {
  return apiClient.get(`/sections`);
};

export const transactionFilter = ({ selectedUsers, postUrlForTransaction }) => {
  return apiClient.get(
    `/clients/${selectedUsers}/recenttransactions?${postUrlForTransaction}`
  );
};

export const transactionUpcomingFilter = ({
  selectedUsers,
  postUrlForUpcomingTransaction,
}) => {
  return apiClient.get(
    `/clients/${selectedUsers}/upcomingtransactions?${postUrlForUpcomingTransaction}`
  );
};

export const ledgerReport = ({ url }) => {
  return apiClient.get(`/LedgerReports?${url}`);
};

export const ledgerReportDetails = ({ url }) => {
  return apiClient.get(`/LedgerDetailedReports?${url}`);
};
export const marginFilter = ({ reportType, userId, accountNo }) => {
  return apiClient.get(
    `MarginStatement${reportType}Reports?userid=${userId}&account=${accountNo}`
  );
};

export const billsFilter = ({
  userid,
  account,
  reporttype,
  segmenttype,
  startdate,
  enddate,
}) => {
  // const url = "BillContractReports";
  // const params = {
  //   userid,
  //   account,
  //   reporttype,
  //   segmenttype,
  //   startdate: startdate,
  //   enddate: enddate,
  // };
  return apiClient.get(
    `BillContractReports?userid=${userid}&account=${account}&reporttype=${reporttype}&segmenttype=${segmenttype}&startdate=${startdate}&enddate=${enddate}`

    //   url, {
    //   params,
    // }
  );
};

export const taxFilter = ({
  taxType,
  userid,
  account,
  startdate,
  enddate,
  withChanges,
}) => {
  return apiClient.get(
    `GetCapgainData${taxType}?userid=${userid}&account=${account}&startdate=${startdate}&enddate=${enddate}&withChanges=${withChanges}`
  );
};

export const getTaxReportPdf = ({ params }) => {
  const url = "DownloadCapgainReportPDF";

  return plainApiClient.post(url, params, {
    responseType: "blob",
  });
};

export const unrealisedGLReportPDfDownload = ({ params, controller }) => {
  const url = "DownloadUnrealisedReportPDF";

  return plainApiClient.post(url, params, {
    responseType: "blob",
    signal: controller.signal,
  });
};

export const getUsersInception = ({ userId }) => {
  return apiClient.get(`clients/${userId}`);
};
